import { Box, InputAdornment, InputBase, Snackbar, Theme } from '@mui/material';
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import MicIcon from '@mui/icons-material/Mic';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    searchBox: {
      display: 'flex',
      alignItems: 'center',
      // marginTop: theme.spacing(2),
      width: '100%',
      '@media (min-width: 1920px) and (max-width: 1940px)': {
        width: '95%',
      },
      '@media (min-width: 1440px) and (max-width: 1460px)': {
        width: '95%',
      },
      border: '0.38px solid #B2B3B7',
      borderRadius: '5px',
      // padding: 2,
    },
    inputBase: {
      backgroundColor: 'white',
      borderRadius: '5px',
      padding: theme.spacing(1),
      flexGrow: 1,
    },
  })
);

interface AppSearchBarProps {
  handleMicHold: () => void;
  handleMicRelease: () => void;
  localSearchInput: any;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  openSnackbar: boolean;
}
const AppSearchBar: React.FC<AppSearchBarProps> = ({ handleMicHold, handleMicRelease, localSearchInput, handleChange, openSnackbar }) => {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.searchBox}>
        <InputBase
          sx={{
            borderRadius: '9px',
            height: '36px',
            fontSize: '12px',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              height: '24px',
              fontSize: '10px !important',
              borderRadius: '9px',
            },
          }}
          placeholder="Search"
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon
                sx={{
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '15px !important',
                  },
                }}
              />
            </InputAdornment>
          }
          endAdornment={
            <InputAdornment position="end" onMouseDown={handleMicHold} onMouseUp={handleMicRelease} style={{ cursor: 'pointer' }}>
              <MicIcon
                sx={{
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '15px !important',
                  },
                }}
              />
            </InputAdornment>
          }
          className={classes.inputBase}
          value={localSearchInput}
          onChange={handleChange}
        />
      </Box>
      <Snackbar open={openSnackbar} onClose={() => {}} message="Microphone is on. You can speak now." />
    </>
  );
};

export default AppSearchBar;
